import { render } from "./Modal.vue?vue&type=template&id=0c153d76&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=0c153d76&lang=less&scoped=true"
import "./Modal.vue?vue&type=style&index=1&id=0c153d76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c153d76"]])

export default __exports__